import { render } from "./SocialCounter.vue?vue&type=template&id=045527c6"
import script from "./SocialCounter.vue?vue&type=script&lang=js"
export * from "./SocialCounter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__